import script from "./MyExcelScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./MyExcelScreen.vue?vue&type=script&setup=true&lang=js"

import "./MyExcelScreen.vue?vue&type=style&index=0&id=0869c370&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0869c370"]])

export default __exports__